import { weddingConfig } from '@/data/weddingConfig';
import { weddingImages } from '@/data/weddingImages';
import WeddingImage from '@/components/base/WeddingImage';
import ScrollReveal from '@/components/feature/ScrollReveal';
import { nameFontSize } from './nameSizing';

export default function FinalPhoto() {
  return (
    <section className="relative flex min-h-[85svh] w-full items-center justify-center overflow-hidden bg-background-950 py-24 md:min-h-[80svh]">
      {/* Background photograph under a deep espresso veil */}
      <div className="absolute inset-0">
        <WeddingImage
          src={weddingImages.finalPhoto.src}
          fallback={weddingImages.finalPhoto.fallback}
          alt={weddingImages.finalPhoto.alt}
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-950/55" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/40 via-transparent to-background-950/70" />
      </div>

      <div className="relative z-10 mx-auto max-w-2xl px-6 text-center">
        <ScrollReveal>
          <p className="font-heading text-xl italic leading-relaxed text-background-50 drop-shadow-md sm:text-2xl md:text-3xl">
            Nos hará muy felices celebrar este momento contigo.
          </p>
        </ScrollReveal>

        {/* Ornamental divider */}
        <ScrollReveal delay={1}>
          <div className="mt-12 flex items-center justify-center gap-3 opacity-70">
            <span className="h-px w-14 bg-primary-300/70" />
            <span className="h-1.5 w-1.5 rotate-45 bg-primary-300/70" />
            <span className="h-px w-14 bg-primary-300/70" />
          </div>
        </ScrollReveal>

        <ScrollReveal delay={2}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
            <span
              className="font-script text-balance break-words text-background-50 drop-shadow-md"
              style={{ fontSize: nameFontSize(weddingConfig.brideName, 'closing') }}
            >
              {weddingConfig.brideName}
            </span>
            <span className="font-heading text-lg text-background-50/80 sm:text-xl md:text-2xl">
              &
            </span>
            <span
              className="font-script text-balance break-words text-background-50 drop-shadow-md"
              style={{ fontSize: nameFontSize(weddingConfig.groomName, 'closing') }}
            >
              {weddingConfig.groomName}
            </span>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={3}>
          <p className="mt-10 font-body text-xs uppercase tracking-[0.3em] text-background-50/80 sm:text-sm">
            {weddingConfig.day} · {weddingConfig.month} · {weddingConfig.year}
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}